var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReportTab
    ? _c("div", { staticClass: "jmreport-report-page" }, [
        _c("iframe", {
          staticClass: "jmreport-report-page__iframe",
          attrs: { src: _vm.reportPath, frameborder: "0" }
        })
      ])
    : _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": {
              flex: "1 1 auto",
              width: "100%",
              "max-width": "none"
            },
            "right-style": { display: "none" }
          },
          on: {
            onSize: function($event) {
              _vm.resizeCache = $event
            }
          }
        },
        [
          _c("template", { slot: "left" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "jmreport-left"
              },
              [
                _c(
                  "div",
                  { staticClass: "jmreport-left__filter" },
                  [
                    _c("el-input", {
                      staticClass: "jmreport-left__search",
                      attrs: {
                        size: "small",
                        clearable: "",
                        placeholder: "搜索报表"
                      },
                      model: {
                        value: _vm.filterText,
                        callback: function($$v) {
                          _vm.filterText = $$v
                        },
                        expression: "filterText"
                      }
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.toDesignReport }
                      },
                      [_vm._v("设计报表")]
                    )
                  ],
                  1
                ),
                _c("el-tree", {
                  ref: "tree",
                  staticClass: "jmreport-left__tree",
                  attrs: {
                    data: _vm.treeData,
                    props: _vm.treeProps,
                    "node-key": "uuid",
                    "highlight-current": "",
                    "default-expand-all": "",
                    "filter-node-method": _vm.filterNode
                  },
                  on: { "node-click": _vm.onNodeClick }
                })
              ],
              1
            )
          ]),
          _c("template", { slot: "right" })
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }